import React, { useCallback, useContext, useEffect, useRef } from 'react'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextButton from 'components/Luxkit/Button/TextButton'
import { connect } from 'react-redux'
import InlineGroup from 'components/Common/InlineGroup'
import useToggle from 'hooks/useToggle'
import { getSupportContact } from 'selectors/supportContactSelector'
import BodyText from 'components/Luxkit/Typography/BodyText'
import HeaderContactOptionsModal from 'components/App/Header/HeaderContactOptions/HeaderContactOptionsModal'
import NavigationHeaderContactDropdown from 'components/App/Header/HeaderMain/NavigationHeader/NavigationHeaderContactDropdown'
import styled from 'styled-components'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import { isLoggedIn } from 'selectors/accountSelectors'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useIsMobileScreen } from 'lib/deviceUtils'
import ModalContext from 'contexts/ModalContext'

interface Props {
  className?: string;
  currentContact: App.GeoContacts;
  loggedIn: boolean;
}

const Relative = styled(InlineGroup)`
  position: relative;
`

function ContactOptions(props: Props) {
  const { currentContact } = props
  const { value: isOpen, on: setOpen, off: setClose } = useToggle(false)
  const triggerRef = useRef(null)
  const { currentRegionCode } = useContext(GeoContext)
  const isMobile = useIsMobileScreen()
  const showModal = useContext(ModalContext)
  const isIndiaRegion = currentRegionCode === 'IN'

  useEffect(() => {
    if (isOpen && isMobile) {
      showModal(<HeaderContactOptionsModal />).then(() => {
        setClose()
      })
    }
  }, [isOpen, isMobile, setClose, showModal])

  const defaultContact = currentContact[currentContact.default]
  const toggleOpen = useCallback(() => {
    if (isOpen) setClose()
    else setOpen()
  }, [isOpen, setClose, setOpen])

  const contactTagLine = isIndiaRegion ? 'Call us 7 days' : 'Call us 24 hours, 7 days'
  return <Relative vertical="center">
    <Group direction="horizontal" verticalAlign="center">
      <BodyText variant="small" wrap="no-wrap">{contactTagLine}</BodyText>
    </Group>
    <TextButton
      kind="tertiary"
      onClick={toggleOpen}
      aria-expanded={isOpen}
      aria-label={contactTagLine + 'contact us'}
      size="medium"
      startIcon={<LinePhoneIcon />}
      endIcon={<DropdownChevron open={isOpen}/>}
      ref={triggerRef}
    >
      {defaultContact.humanReadable}
    </TextButton>
    <CSSBreakpoint min="tablet">
      <NavigationHeaderContactDropdown
        alignment="center"
        isOpen={isOpen}
        onPhoneToggle={toggleOpen}
        triggerRef={triggerRef}
      />
    </CSSBreakpoint>
  </Relative>
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
    loggedIn: isLoggedIn(state),
  }
}

export default connect(mapStateToProps)(ContactOptions)
